import { FieldType, PrintPublicationInfoField } from '../../../components/GenericSection';
import { CITY, PUBLISHER, SOURCE_TITLE, STATE, YEAR } from '../../constants';
export var PRINT_SECTION_FIELDS = [{
  field: PrintPublicationInfoField.TITLE,
  labelText: SOURCE_TITLE,
  recommended: true,
  type: FieldType.TEXT
}, {
  fields: [{
    field: PrintPublicationInfoField.PUBLISHER,
    labelText: PUBLISHER,
    recommended: true,
    type: FieldType.TEXT
  }, {
    field: PrintPublicationInfoField.CITY,
    labelText: CITY,
    recommended: true,
    type: FieldType.TEXT
  }, {
    field: PrintPublicationInfoField.STATE,
    labelText: STATE,
    recommended: true,
    type: FieldType.TEXT
  }, {
    field: PrintPublicationInfoField.YEAR,
    labelText: YEAR,
    recommended: true,
    type: FieldType.TEXT
  }]
}];